import { render } from "./UserLoginPage.vue?vue&type=template&id=c4af4e5e&scoped=true&ts=true"
import script from "./UserLogin.component.ts?vue&type=script&lang=ts"
export * from "./UserLogin.component.ts?vue&type=script&lang=ts"

import "./userLogin.scss?vue&type=style&index=0&id=c4af4e5e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/richcle-kyc-fe/richcle-kyc-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4af4e5e"]])

export default __exports__